export const KEYVALUE_CONFIG_TYPE = "KEYVALUE";

export const isKeyValueConfig = (config) => (
  Boolean(config && String(config.configtype || "").toUpperCase() === KEYVALUE_CONFIG_TYPE)
);

const parseKeyValueConfig = (value) => {
  const map = new Map();
  const order = [];
  let fullyParsed = true;

  String(value ?? "").split(/\r?\n/).forEach((line) => {
    if (!line || !line.trim()) return;

    const parts = line.split(":");
    const key = parts.length >= 2 ? parts[0].trim() : "";
    if (parts.length < 2 || !key) {
      fullyParsed = false;
      return;
    }

    const parsedValue = parts.slice(1).join(":").trimStart();
    if (!map.has(key)) {
      order.push(key);
    }
    map.set(key, parsedValue);
  });

  return { map, order, fullyParsed };
};

const shouldCompareRaw = (left, right) => (
  !left.fullyParsed || !right.fullyParsed || (left.map.size === 0 && right.map.size === 0)
);

export const areKeyValueConfigsEqual = (leftValue, rightValue) => {
  const left = parseKeyValueConfig(leftValue);
  const right = parseKeyValueConfig(rightValue);

  if (shouldCompareRaw(left, right)) {
    return String(leftValue ?? "") === String(rightValue ?? "");
  }

  if (left.map.size !== right.map.size) return false;

  for (const [key, value] of left.map) {
    if (!right.map.has(key)) return false;
    if (String(right.map.get(key)).trim() !== String(value).trim()) return false;
  }

  return true;
};

export const areConfigValuesEqual = (originalValue, nextValue, configType) => {
  if (String(configType || "").toUpperCase() === KEYVALUE_CONFIG_TYPE) {
    return areKeyValueConfigsEqual(originalValue, nextValue);
  }
  return String(originalValue ?? "") === String(nextValue ?? "");
};

export const diffKeyValueConfig = (originalValue, nextValue) => {
  const original = parseKeyValueConfig(originalValue);
  const next = parseKeyValueConfig(nextValue);

  if (shouldCompareRaw(original, next)) {
    if (String(originalValue ?? "") === String(nextValue ?? "")) return [];
    return [{ key: "", oldVal: String(originalValue ?? ""), newVal: String(nextValue ?? "") }];
  }

  const keys = [];
  const seen = new Set();

  original.order.concat(next.order).forEach((key) => {
    if (seen.has(key)) return;
    seen.add(key);
    keys.push(key);
  });

  return keys.reduce((changes, key) => {
    const existed = original.map.has(key);
    const exists = next.map.has(key);
    const oldVal = existed ? original.map.get(key) : "";
    const newVal = exists ? next.map.get(key) : "";

    if (existed && exists && String(oldVal).trim() === String(newVal).trim()) {
      return changes;
    }

    changes.push({ key, oldVal, newVal });
    return changes;
  }, []);
};
